<app-alert class="d-block mb-3 text-start" [title]="'btw-nummer-onjuist-alert-titel' | fromDictionary" [status]="'type--danger'">
  <p class="my-2">{{ 'btw-nummer-onjuist-alert-tekst' | fromDictionary }}</p>

  <div class="d-flex flex-column gap-2 align-items-start">
    <a class="button button--light button--sm" [routerLink]="['/account/bewerken']" [queryParams]="{ returnUrl: '/cart' }">
      <span>{{ 'btw-nummer-onjuist-alert-knoptekst' | fromDictionary }}</span>
    </a>
    <a class="button button-outline button--danger button--sm ms-0" (click)="proceed.emit()">
      <span>{{ 'btw-nummer-onjuist-alert-doorgaan-knoptekst' | fromDictionary }}</span>
    </a>
  </div>
</app-alert>
